<template>
  <div
    class="fixed z-20 top-0 left-0 min-h-dvh min-w-full bg-gray-900 bg-opacity-50"
    data-testid="sidebar-overlay"
  >
    <div @click.stop>
      <slot></slot>
    </div>
  </div>
</template>
